import React from 'react';
import SingleImage from "../../components/sem/SingleImage"
import { _storageSettings } from "../../storage/storageHelpers"
import { getGalleryImage } from "./StorageReducer"

export const rts = {
  handleSet_appStorageUrl: 'handleSet_appStorageUrl',
  handleImageVisible: 'handleImageVisible',
  handleSet_galleryImage: 'handleSet_galleryImage',
  handleSet_galleryImageDirect: 'handleSet_galleryImageDirect',
  handleShow_imageUpload: 'handleShow_imageUpload',
}

export const imageReducer = (state, action) => {

  const { type, dispatch, _imageOpts } = action

  const { handleSet_galleryImage } = imageHandlers(dispatch)

  switch (type) {

    case rts.handleSet_appStorageUrl:

    case rts.handleSet_galleryImage:
      const { fullImageProps } = action
      const _trueImageUrl = fullImageProps ? getTrueUrl(fullImageProps, _imageOpts) : null
      return fullImageProps ? { ...state, fullImageProps, _trueImageUrl } : { ...state, fullImageProps: {} }

    case rts.handleSet_galleryImageDirect:
      const { _imageUrls } = action
      const { full } = _imageUrls ?? {}
      return { ...state, fullImageProp: {}, _trueImageUrl: full }

    case rts.handleImageVisible:
      if (state.fullImageProps) {
        let ve = getCardElement(state, action, true)
        return { ...state, cardImageElement: ve }
      } else {
        return { ...state }
      }

    case rts.handleShow_imageUpload:
      return { ...state, showImageUpload: !state.showImageUpload }

    default:
      return { ...state }
  }
}

export const imageInitialState = (initState) => {
  return { ...initState }
};

export const imageHandlers = (dispatch) => {
  return {
    handleImageVisible: (imageOptions) => { dispatch({ type: rts.handleImageVisible, dispatch, imageOptions }) },
    handleSet_galleryImage: (fullImageProps, _imageOpts) => { dispatch({ type: rts.handleSet_galleryImage, dispatch, fullImageProps, _imageOpts }) },
    handleSet_galleryImageDirect: (_imageUrls, _imageOpts) => { dispatch({ type: rts.handleSet_galleryImageDirect, dispatch, _imageUrls, _imageOpts }) },
    handleShow_imageUpload: () => { dispatch({ type: rts.handleShow_imageUpload, dispatch }) },
  }
}

const getTrueUrl = (fullImageProps, _imageOpts) => {

  const { urls: urls_current } = fullImageProps ?? {}
  const { thumbnail: current_url_thumbnail, full: current_url_full } = urls_current ?? {}

  const { showFullImage } = _imageOpts

  let _trueImageUrl;

  if ((showFullImage) && current_url_full) {
    _trueImageUrl = current_url_full
  } else if (current_url_thumbnail) {
    _trueImageUrl = current_url_thumbnail
  }

  return _trueImageUrl

}

const getCardElement = (state, action, isVisible) => {
  const { fullImageProps, _trueImageUrl, transition_image } = state
  const { imageOptions } = action
  if (fullImageProps) {
    if (isVisible) {
      const cip = { ...state, _trueImageUrl, fullImageProps, transition_image, ...imageOptions }
      return { type: 'image', element: <SingleImage {...cip} /> }
    }
  }
}